import React from 'react'
import moment from 'moment'
import { ClipLoader } from 'react-spinners'
import api from '../../../../Api'
import { Button, Alert, Table } from 'reactstrap'
import { SharedSlidingPane } from '../../../../components/SharedSlidingPage'
import ScrollContainer from 'react-indiana-drag-scroll'
import { ModalDetailedTime } from './ModalDetailedTime'
import { ModalDetailedDeleteTime } from './ModalDetailedDeleteTime'
import { ModalDetailedTimeForm } from './ModalDetailedTimeForm'

class Detailed extends React.Component {
  constructor (props) {
    super(props)
    this.altDefault = 55
    this.altMultiplayer = 26
    window.dashdetailed = this

    this.state = {
      editingTime: null,
      newTime: '00:00:00', 
      loading: false,
      alert: {
        isOpen: false,
        color: 'danger',
        message: ''
      },

      isDeleteModalOpen: false,
      isEditModalOpen: false,
      isAddModalOpen: false,
      selectedRecord: null,
      isSlidingPageOpen: false,
      selectedUserData: null,
      selectedLessonData: null,
      openDeletePane: false,
      openEditPane: false,
      openAddPane: false,
      selectedDate: moment().format('DD/MM/YYYY'),
      dateTime: moment().format('HH:mm')
    }
  }

  showAlert = (message, color = 'danger') => {
    this.setState({
      alert: {
        isOpen: true,
        color,
        message
      }
    })
    setTimeout(() => {
      this.setState({
        alert: {
          isOpen: false,
          color: 'danger',
          message: ''
        }
      })
    }, 5000)
  }

  async componentDidMount () {}

  
  //Para somar todos os times
  sumAllTime (times) {
    var total = 0

    for (var i = 0; i < times.length; i++) {
      var hms = times[i].time
      var a = hms.split(':')

      var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2]
      total += seconds
    }

    var t = moment('00:00:00', 'HH:mm:ss')
      .add(total, 'seconds')
      .format('HH:mm:ss')
    return t

    
  }

  countGroupedDays(userId) {
    let totalDays = 0;
    this.props.state.progress.lessons.forEach(lesson => {
      const records = this.props.state.progress.users
        .find(u => u.id === userId)
        ?.progress[lesson.id] || [];
      const groupedTimesByDay = {};
      records.forEach(record => {
        const dayKey = moment(record.createDate, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
        if (!groupedTimesByDay[dayKey]) groupedTimesByDay[dayKey] = 0;
      });
      totalDays += Object.keys(groupedTimesByDay).length;
    });
    return totalDays;
  }

  handleTimeUpdate = async newTime => {
    const { editingTime, selectedDate, dateTime } = this.state;
    if (!editingTime) return;

    try {
      if (!moment(newTime, 'HH:mm:ss', true).isValid()) {
        throw new Error('Formato de tempo inválido. Use HH:mm:ss');
      }

      this.setState({ loading: true });

      const response = await api.getProgressForCrud(
        this.props.state.classRoom.id,
        editingTime.lessonId,
        editingTime.userId
      );

      console.log("editingTime:", JSON.stringify(editingTime, null, 2));
      const records = response.data;

      const recordToUpdate = records.find(record => 
        parseInt(record.user) === parseInt(editingTime.userId) && 
        parseInt(record.lesson) === parseInt(editingTime.lessonId) && 
        record.time === editingTime.oldTime
      );

      console.log("Record to update:", JSON.stringify(recordToUpdate, null, 2));
      if (!recordToUpdate) {
        throw new Error('Registro não encontrado');
      }

      const formattedDateTime = moment(`${selectedDate} ${dateTime}`, 'DD/MM/YYYY HH:mm')
        .format('YYYY-MM-DD HH:mm:ss');
      
      const updateResponse = await api.updateProgressById(recordToUpdate.id, {
        newTime: newTime,
        newDate: formattedDateTime
      });

      // Atualizar o estado local
      const updatedProgress = { ...this.props.state.progress };
      const userProgress = updatedProgress.users.find(u => u.id === editingTime.userId);
      if (userProgress) {
        const lessonProgress = userProgress.progress[editingTime.lessonId];
        const recordIndex = lessonProgress.findIndex(r => 
          r.time === editingTime.oldTime && 
          moment(r.createDate).isSame(moment(editingTime.createDate))
        );
        
        if (recordIndex !== -1) {
          lessonProgress[recordIndex] = {
            ...lessonProgress[recordIndex],
            time: newTime,
            createDate: formattedDateTime,
            displayDate: selectedDate,
            displayTime: dateTime
          };
        }
      }
      
      this.props.state.progress = updatedProgress;
      this.setState({
        editingTime: null,
        loading: false,
        isEditModalOpen: false,
        openEditPane: false
      });
      this.showAlert('Tempo atualizado com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao atualizar tempo:', error);
      this.showAlert('Erro ao atualizar o registro: ' + (error.response?.data?.msg || error.message));
      this.setState({ loading: false });
    }
  };

  handleTimeDelete = async () => {
    const { selectedRecord } = this.state;
    if (!selectedRecord) return;

    try {
        this.setState({ loading: true });

        const response = await api.getProgressForCrud(
            this.props.state.classRoom.id,
            selectedRecord.lessonId,
            selectedRecord.userId
        );

        const records = response.data;

        const recordToDelete = records.find(record => 
            parseInt(record.user) === parseInt(selectedRecord.userId) && 
            parseInt(record.lesson) === parseInt(selectedRecord.lessonId) && 
            record.time === selectedRecord.time
        );

        if (!recordToDelete) {
            throw new Error('Registro não encontrado');
        }

        console.log('Deletando registro:', recordToDelete);

        await api.deleteProgressById(recordToDelete.id);

        const updatedProgress = { ...this.props.state.progress };
        const userProgress = updatedProgress.users.find(u => u.id === selectedRecord.userId);

        if (userProgress) {
            const lessonProgress = userProgress.progress[selectedRecord.lessonId];
            const recordIndex = lessonProgress.findIndex(record => 
                record.time === selectedRecord.time && 
                moment(record.createDate).isSame(moment(selectedRecord.createDate))
            );
            
            if (recordIndex !== -1) {
                lessonProgress.splice(recordIndex, 1);
            }
        }

        this.props.state.progress = updatedProgress;
        this.setState({
            isDeleteModalOpen: false,
            selectedRecord: null,
            loading: false,
            openDeletePane: false
        });
        
        this.showAlert('Registro excluído com sucesso!', 'success');
    } catch (error) {
        console.error('Erro ao excluir registro:', error);
        this.showAlert('Erro ao excluir o registro: ' + (error.response?.data?.msg || error.message));
        this.setState({ loading: false });
    }
  };

  handleTimeAdd = async () => {
    const { selectedRecord, newTime, selectedDate, dateTime } = this.state;
    if (!selectedRecord) return;

    try {
      if (!moment(newTime, 'HH:mm:ss', true).isValid()) {
        throw new Error('Formato de tempo inválido. Use HH:mm:ss');
      }

      if (!moment(selectedDate, 'DD/MM/YYYY', true).isValid()) {
        throw new Error('Formato de data inválido. Use DD/MM/YYYY');
      }

      this.setState({ loading: true });

      // Formato que o backend espera
      const formattedDateTime = moment(`${selectedDate} ${dateTime}`, 'DD/MM/YYYY HH:mm')
        .format('YYYY-MM-DD HH:mm:ss');
      
      const data = {
        user: parseInt(selectedRecord.userId),
        lesson: parseInt(selectedRecord.lessonId),
        classRoom: parseInt(this.props.state.classRoom.id),
        newTime: newTime,
        newDate: formattedDateTime
      };

      const response = await api.addProgressCompound(data);
      
      console.log('Resposta da API:', response);
      
      const responseCreateDate = response && response.record && response.record.createDate;

  
      const updatedProgress = { ...this.props.state.progress };
      const userProgress = updatedProgress.users.find(
        u => u.id === selectedRecord.userId
      );
      if (userProgress) {
        const newRecord = {
          time: newTime,
          createDate: responseCreateDate || formattedDateTime,
          displayDate: selectedDate,
          displayTime: dateTime
        };
        userProgress.progress[selectedRecord.lessonId].push(newRecord);
      }

      this.props.state.progress = updatedProgress;
      this.setState({
        isAddModalOpen: false,
        selectedRecord: null,
        newTime: '',
        loading: false,
        openAddPane: false 
      });
      this.showAlert('Tempo adicionado com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar tempo:', error);
      this.showAlert('Erro ao adicionar o registro: ' + error.message);
      this.setState({ loading: false });
    }
  }

  handleTimeEdit = (userId, lessonId, oldTime) => {
    this.setState({
      editingTime: {
        userId,
        lessonId,
        oldTime
      },
      newTime: oldTime
    })
  }

  toggleDeleteModal = (userId, lessonId, time) => {
    this.setState(state => ({
      isDeleteModalOpen: !state.isDeleteModalOpen,
      selectedRecord: state.isDeleteModalOpen
        ? null
        : { userId, lessonId, time }
    }))
  }

  toggleEditModal = (userId, lessonId, oldTime) => {
    this.setState(state => ({
      isEditModalOpen: !state.isEditModalOpen,
      editingTime: state.isEditModalOpen
        ? null
        : {
            userId,
            lessonId,
            oldTime
          },
      newTime: oldTime || ''
    }))
  }

  toggleAddModal = (userId, lessonId) => {
    this.setState(state => ({
      isAddModalOpen: !state.isAddModalOpen,
      selectedRecord: state.isAddModalOpen ? null : { userId, lessonId },
      newTime: ''
    }))
  }

  toggleDeletePane = (userId, lessonId, time, createDate, id) => {
    this.setState(state => ({
      openDeletePane: !state.openDeletePane,
      selectedRecord: state.openDeletePane ? null : { 
        userId, 
        lessonId, 
        time,
        createDate,
        id
      }
    }))
  }

  toggleEditPane = (userId, lessonId, oldTime, oldDateTime, recordId) => {
    const recordDate = oldDateTime ? moment(oldDateTime).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY');
    const recordTime = oldDateTime ? moment(oldDateTime).format('HH:mm') : moment().format('HH:mm');

    this.setState(state => ({
      openEditPane: !state.openEditPane,
      editingTime: state.openEditPane
        ? null
        : {
            userId,
            lessonId,
            oldTime,
            createDate: oldDateTime,
            recordId
          },
      newTime: oldTime || '00:00:00',
      selectedDate: recordDate,
      dateTime: recordTime
    }))

    console.log("recordId:", recordId);
  }

  toggleAddPane = (userId, lessonId) => {
    this.setState(state => ({
      openAddPane: !state.openAddPane,
      selectedRecord: state.openAddPane ? null : { userId, lessonId },
      newTime: '00:00:00' 
    }))
  }

  handleDateChange = (e) => {
    this.setState({ selectedDate: e.target.value });
  };

  handleDateTimeChange = (e) => {
    this.setState({ dateTime: e.target.value })
  }

  render () {
    const {
      isDeleteModalOpen,
      isEditModalOpen,
      isAddModalOpen,
      loading,
      newTime,
      alert,
      openDeletePane,
      openEditPane,
      openAddPane
    } = this.state

    return (
      <React.Fragment>
        {alert.isOpen && (
          <div
            style={{
              position: 'fixed',
              top: '20px',
              right: '20px',
              zIndex: 9999,
              minWidth: '300px'
            }}
          >
            <Alert
              color={alert.color}
              isOpen={alert.isOpen}
              toggle={() =>
                this.setState({ alert: { ...alert, isOpen: false } })
              }
            >
              {alert.message}
            </Alert>
          </div>
        )}
        <div className='row'>
          {this.props.state.loadProgres !== true && (
            <React.Fragment>
              <div
                className='col-md-12'
                style={{ marginTop: '40px', marginBottom: '30px' }}
              >
                <center>
                  <ClipLoader
                    sizeUnit={'px'}
                    size={60}
                    color={'#adb5bd'}
                    loading={true}
                  />
                </center>
              </div>
            </React.Fragment>
          )}

          <div
            className='col-md-2 box_left_detailed'
            style={{ boxShadow: '8px 0px 14px -20px #000' }}
          >
            {this.props.state.loadProgres === true && (
              <React.Fragment>
                <div
                  className='dashboard_class_user'
                  style={{ borderTop: '1px solid #ffffff00', height: '28px' }}
                ></div>
                {this.props.state.progress.users.map((value, index) => {
                  var tot = this.countGroupedDays(value.id)
                  //console.log(tot);

                  var height = tot * this.altMultiplayer
                  if (height === 0 || height < 55) {
                    height = this.altDefault + height
                  }
                  var sty = { height: height + 'px' }

                  if (this.props.state.openTimes[value.id] === true) {
                    sty = { height: height + 'px' }
                  } else {
                    sty = { height: this.altDefault + 'px' }
                  }

                  var css = { cursor: 'pointer', display: 'flex' }
                  if (value.userInClass === false) {
                    css.opacity = '0.5'
                  }

                  return (
                    <React.Fragment key={value.id}>
                      <div
                        className='dashboard_class_user dashboard_class_user_5'
                        style={sty}
                      >
                        <div className='name_user'>
                          <div
                            onClick={() => this.props.openChartUser(value)}
                            style={css}
                          >
                            <img
                              alt='...'
                              className='avatar rounded-circle mr-3'
                              src={value.photo}
                            />
                            <input
                              style={{ cursor: 'pointer', width: '130px' }}
                              readOnly
                              className='inputViwerName_classroom '
                              value={'' + value.name + ' ' + value.lastName}
                            />
                          </div>
                          {this.props.state.openTimes[value.id] !== true && (
                            <button
                              onClick={() => this.props.openUser(value.id)}
                              type='button'
                              className='buttonOpenDashBoard btn-icon-only rounded-circle btn btn-secondary'
                            >
                              <span className='btn-inner--icon'>
                                <i className='fas fa-chevron-down'></i>
                              </span>
                            </button>
                          )}
                          {this.props.state.openTimes[value.id] === true && (
                            <button
                              onClick={() => this.props.closeUser(value.id)}
                              type='button'
                              className='buttonOpenDashBoard btn-icon-only rounded-circle btn btn-secondary'
                            >
                              <span className='btn-inner--icon'>
                                <i className='fas fa-chevron-up'></i>
                              </span>
                            </button>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </React.Fragment>
            )}
          </div>

          {this.props.state.loadProgres === true && (
            <div className='col-md-10' style={{ paddingLeft: '0px' }}>
              <ScrollContainer
                id='over_mouse_t'
                className='scroll-container'
                style={{ overflow: 'auto' }}
              >
                <div
                  className='listLessonsTop'
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '0px',
                    boxShadow: '0px 5px 8px -11px #000'
                  }}
                >
                  {this.props.state.progress.lessons.map((value, index) => {
                    return (
                      <React.Fragment key={value.id}>
                        <div className='lessonTop'>
                          <i className={window.iconsLesson[value.icon]}></i>{' '}
                          <font style={{ fontWeight: '700' }}>
                            {value.name}
                          </font>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </div>

                {this.props.state.progress.users.map((value, index) => {
                  var tot = this.countGroupedDays(value.id)
                  var sty
                  //console.log(tot);

                  var height = tot * this.altMultiplayer
                  if (height === 0 || height < 55) {
                    height = this.altDefault + height
                  }

                  if (this.props.state.openTimes[value.id] === true) {
                    sty = { height: height + 'px' }
                  } else {
                    sty = { height: this.altDefault + 'px' }
                  }

                  if (index === 0) {
                    sty.borderTop = '1px solid #e9ecef00'
                  }

                  return (
                    <React.Fragment key={index}>
                      <div
                        className='dashboard_class_userList_user'
                        style={sty}
                      >
                        <React.Fragment>
                          {this.props.state.progress.lessons.map(
                            (value2, index2) => {
                              var cl

                              if (
                                this.props.state.openTimes[value.id] === true
                              ) {
                                cl = 'resto_progresso'
                                height = 20
                                sty = {}
                              } else {
                                cl = 'resto_progresso hidden_progress'
                                sty = {}
                              }

                              const groupedTimesByDay = {};
                              value.progress[value2.id].forEach((record) => {
                                const dayKey = moment(record.createDate, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
                                if (!groupedTimesByDay[dayKey]) groupedTimesByDay[dayKey] = 0;
                                const [hh, mm, ss] = record.time.split(':').map(Number);
                                groupedTimesByDay[dayKey] += (hh * 3600) + (mm * 60) + ss;
                              });

                              const groupedList = Object.keys(groupedTimesByDay).map(day => {
                                const totalSeconds = groupedTimesByDay[day];
                                const totalTime = moment.utc(totalSeconds * 1000).format('HH:mm:ss');
                                return { day, time: totalTime };
                              });

                              return (
                                <div
                                  key={index2}
                                  className='listTime_dashboard_class_room'
                                  style={{ ...sty, cursor: 'pointer' }}
                                  onClick={() =>
                                    this.setState({
                                      isSlidingPageOpen: true,
                                      selectedUserData: value,
                                      selectedLessonData: value2
                                    })
                                  }
                                  title="Número abaixo é o somado do dia. Clique para visualizar todos os registros."
                                >
                                  <div
                                    user={value.id}
                                    lesson={value2.id}
                                    className='rrasta animated'
                                    style={{
                                      cursor: 'grab',
                                      padding: '15px 0px 0px 0px',
                                      height: '35px'
                                    }}
                                    title='Este número mostra o total já somado no dia. Para ver cada registro individual, clique para expandir.'
                                  >
                                    <font className='time_progress'>
                                      {this.sumAllTime(
                                        value.progress[value2.id]
                                      )}
                                    </font>
                                    <font className='tot_register'>
                                      {value.progress[value2.id].length}
                                    </font>
                                  </div>
                                  <div className={cl}>
                                    {groupedList.map((item, idx) => (
                                      <div key={idx} className='outras_tentativas d-flex align-items-center'>
                                        <div className='d-flex align-items-center'>
                                          <span className='date mr-3'>
                                            {item.day}
                                          </span>
                                          <span className='timer'>
                                            {item.time}
                                          </span>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )
                            }
                          )}
                        </React.Fragment>
                      </div>
                    </React.Fragment>
                  )
                })}
              </ScrollContainer>
            </div>
          )}
        </div>

        <SharedSlidingPane
          isOpen={this.state.isSlidingPageOpen}
          title={`${this.state.selectedUserData?.name} ${this.state.selectedUserData?.lastName}`}
          width='500px'
          onClose={() => this.setState({ isSlidingPageOpen: false })}
        >
          <ModalDetailedTime
            selectedUserData={this.state.selectedUserData}
            selectedLessonData={this.state.selectedLessonData}
            onEdit={this.toggleEditPane}
            onDelete={this.toggleDeletePane}
            onAdd={this.toggleAddPane}
            sumAllTime={this.sumAllTime}
          />
        </SharedSlidingPane>

        {/* Painel de deletar */}
        <SharedSlidingPane
          isOpen={openDeletePane}
          title='Confirmação de Exclusão'
          width='400px'
          onClose={this.toggleDeletePane}
        >
          <ModalDetailedDeleteTime
            onConfirm={this.handleTimeDelete}
            onCancel={this.toggleDeletePane}
            loading={loading}
          />
        </SharedSlidingPane>

        {/* Painel de adicionar/remover */}
        <SharedSlidingPane
          isOpen={openEditPane || openAddPane}
          title={openEditPane ? 'Editar Tempo' : 'Adicionar Tempo'}
          width='400px'
          onClose={openEditPane ? this.toggleEditPane : this.toggleAddPane}
        >
          <ModalDetailedTimeForm
            isEdit={openEditPane}
            value={newTime}
            date={this.state.selectedDate}
            dateTime={this.state.dateTime}
            onChange={e => this.setState({ newTime: e.target.value })}
            onDateChange={this.handleDateChange}
            onDateTimeChange={this.handleDateTimeChange}
            onSubmit={() =>
              openEditPane
                ? this.handleTimeUpdate(newTime)
                : this.handleTimeAdd()
            }
            onCancel={openEditPane ? this.toggleEditPane : this.toggleAddPane}
            loading={loading}
          />
        </SharedSlidingPane>
      </React.Fragment>
    )
  }
}

export default Detailed
